

































































import { Component, Mixins } from "vue-property-decorator";
import Overview from "hfox/components/home/Overview.vue";
import Balance from "hfox/components/home/Balance.vue";
import PlanItem from "hfox/components/home/PlanItem.vue";
import Actions from "hfox/components/home/Actions.vue";
import WithdrawModal from "hfox/components/home/WithdrawModal.vue";
import DepositModal from "hfox/components/home/DepositModal.vue";
import EmptyPlanAction from "hfox/components/home/EmptyPlanAction.vue";
import ReceivingWalletAlert from "hfox/components/home/ReceivingWalletAlert.vue";
import { Getter, State } from "vuex-class";
import { Plan } from "@foxone/api/src/models/hfox";
import mixins from "@/mixins";

@Component({
  components: {
    Overview,
    Balance,
    PlanItem,
    Actions,
    WithdrawModal,
    DepositModal,
    EmptyPlanAction,
    ReceivingWalletAlert
  }
})
class Home extends Mixins(mixins.processOrders, mixins.scrollAppbarPage) {
  @State(state => state.hfox.loading) loading;

  @Getter("hfox/getActivePlans") ativePlans!: Plan[];

  @Getter("hfox/getStopPlans") stopPlans!: Plan[];

  withdrawVisible = false;

  depositVisible = false;

  background =
    "linear-gradient(180deg, rgba(68, 209, 240, 1) 50%, rgba(68, 209, 240, 0) 100%)";

  get themeColor(): any {
    return "#44D1F0";
  }

  get home() {
    const home = this.$route.query.home;
    return Boolean(home);
  }

  get title() {
    return this.$t("hfox") as string;
  }

  get meta() {
    return {
      image: require("@/assets/images/background_3.png"),
      hasActive: this.ativePlans.length > 0,
      hasStop: this.stopPlans.length > 0,
      empty: this.ativePlans.length === 0 && this.stopPlans.length === 0
    };
  }

  mounted() {
    this.$store.dispatch("hfox/loadHfoxData");
  }

  handleDeposit() {
    this.depositVisible = true;
  }

  handleWithdraw() {
    this.withdrawVisible = true;
  }

  handleRefresh() {
    this.$store.dispatch("hfox/loadHfoxData");
  }

  handleToDetail(plan: Plan) {
    this.$helper.toFusionPath(this, "hfox", {
      name: "plan-id",
      params: { id: plan.id + "" }
    });
  }
}
export default Home;
